﻿// Fix for jquery ui overriding bootstraps prettier tooltips

var jqeBsTooltip = $.fn.tooltip.noConflict();
$.fn.tlp = jqeBsTooltip;
